<template>
	<div>

		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">
					{{pageIndex == 1 ? "Security Phrase Confirmation" : "Security Phrase"}}</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					
							<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
								<div v-if="pageIndex == 0">
									<div class="phrase-content security-phrase">
										<div class="content-inner">
											<div class="sp-section">
												<h6>Anti-Phishing </h6>
												<p>To better protect you, we're implementing an additional security verification before logging into your
													account. </p>
											</div>
											<div class="sp-section">
												<h6>Security Phrase </h6>
												<p>Enter a phrase only you would know (30 character limit). This phrase will appear on the login screen
													once the Username is entered.</p>
											</div>
											<div class="sp-section form-group">
												<label>Insert your phrase here :</label>
												<input autocomplete="off" id="passphrase" v-model="vModel.PassPhrase" v-validate="'required|min:8|max:30'"
												 data-vv-as='Phrase' v-drag-disable='' :class="{'input': true, 'is-danger': errors.has('passphrase'),'form-control' : true  }"
												 type="text" placeholder="Insert Your Phrase" name="passphrase"   v-only-uppercase/>
												<div v-show="errors.has('passphrase')" class="help is-danger">
													{{ errors.first('passphrase') }}</div>
											</div>
											<div class="sp-section">
												<h6>Note : </h6>
												<p> Please enter a phrase that is easily remembered. DO NOT <br> insert your User ID or Password as
													Security Phrase. </p>
											</div>
											<div class="button-wrap ">
												<button class="btn btn-next" type="submit">Next</button>
											</div>
										</div>
										<!--end Content inner-->
									</div>
									<!--end content-->
								</div>
								<div v-if="pageIndex == 1">
									<div class="phrase-content">
										<div class="content-inner">
											<div class="confirmation sp">
												<strong> Security Phrase Confirmation </strong>
												<p> Are you sure would like to set ? </p>
												<h2 class="text-uppercase"> {{vModel.PassPhrase}} </h2>
												<p> As your security Phrase ? </p>
											</div>



											<div class="button-wrap mar-t150">
												<button class="btn btn-not-me" type="cancel" @click.prevent="onCancel">No</button>
												<button class="btn btn-yes" type="submit">Yes</button>
											</div>
										</div>
										<!--end Content inner-->
									</div>
									<!--end content-->
								</div>

							</form>



				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->







	</div>
</template>

<script>
	import Base from "../../shared/Base.vue";
	import CommonService from "../../services/common";
	import ListService from "../../services/list";

	export default {
		name: "registerpassphrase",		
		extends: Base,
		beforeRouteEnter(to, from, next) {
				next(p => {
					p.vModel.OtpId = to.params.id
				});
			},
		created() {
			if (this.pageIndex == null) {
				this.pageIndex = 0;
			}

		},
		data() {
			return {
				pageIndex: 0,
				vModel: {
					PassPhrase: null,
					OtpId: null,
				}
			};
		},		

		methods: {

			onCancel: function () {
				if (this.pageIndex == 1) {
					this.pageIndex = 0;
				}
			},

			onSubmit() {
				var self = this;
				if (self.isProcessing) return;

				self.$validator.validateAll().then(result => {
					if (result) {

						if (self.pageIndex == 0) {
							self.pageIndex = 1;
						} else if (self.pageIndex == 1) {
							var url = "v2/account/register/confirm/passphrase";
							var model = self.vModel;

							self.isProcessing = true;
							self.$http.post(url, model).then(
								response => {
									self.isProcessing = false;									
									self.$toastr("success", response.body.Message);
                                    setTimeout(() => {
										self.$router.push("/account/login");
									}, 1000)
								},
								error => {
									self.isProcessing = false;
								}
							);
						} 
					}
				});
			}
		}
	};
</script>